import React from 'react'
import ReactDOM from 'react-dom'

const CustomModal = ({
  isOpen,
  onClose,
  title,
  children,
  width = 'max-w-lg',
}) => {
  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50">
      <div className={`bg-white rounded-lg shadow-lg w-full ${width} mx-4`}>
        {/* Modal Header */}
        <div className="p-4 flex justify-between items-center">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900"
          >
            ✕
          </button>
        </div>

        {/* Modal Body */}
        <div className="px-6 pb-6">{children}</div>
      </div>
    </div>,
    document.body // Đảm bảo modal render tại root (body)
  )
}

export default CustomModal
